import {  axiosClient } from '../store';

export async function downloadExcelFile(excelFileName) {
  if (!excelFileName) {
    throw new Error('Excel file name is required');
  }

  const response = await axiosClient.post(
    '/api/v2/documents/temp/doc',
    {
      docfilename: excelFileName
    },
    {
      responseType: 'blob'
    }
  );

  const blob = new Blob([response.data], {
    type: response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = excelFileName;
  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}